<template>
<!-- 员工报存专用组件 -->
  <div class="form">
    <el-form :model="formInfo.data"
             :inline="formInfo.inline"
             :rules="formInfo.rules"
             ref="form"
             :label-width="formInfo.labelWidth"
             style="text-align:left">
      <el-form-item v-for="item of formInfo.list"
                    :key="item.label"
                    :label="item.label"
                    :prop="item.value"
                    :label-width="item.labelWidth?item.labelWidth:''"
                    :class="item.className">
        <el-input v-if="item.type=='text'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
        </el-input>
        <el-input v-if="item.type=='textNum'"
                  v-model="formInfo.data[item.value]"
                  type="text"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  :remote="item.remote"
                  :remote-method="item.remote?remoteMethod:none"
                  @change="selectChangeTtext"
                  :disabled="item.disabled"
                  :placeholder="'请输入'+item.label.slice(0,item.label.length-1)"
                  :style="item.style"
                  size="small"
                  :clearable="item.unclearable?false:true"
                  :readonly="item.readonly"
                  @blur="item.blur?hanClick(item.blur):null"
                  @focus="item.event?hanClick(item.event):null"
                  @keyup.enter.native="hanClick('sub')">
          <template slot="prepend">{{tPrefixion}}</template>
        </el-input>
        <el-select v-else-if="item.type=='select'+item.label"
                   v-model="formInfo.data[item.value]"
                   v-loading="item.vloading"
                   element-loading-spinner="el-icon-loading"
                   filterable
                   :remote="item.remote"
                   :remote-method="item.remote?remoteMethod:none"
                   @change="selectChange($event,item.label)"
                   @focus="item.remote?focus(item.value):''"
                   :loading="item.loading"
                   :disabled="item.disabled"
                   :style="item.style"
                   :placeholder="'请选择'+item.label.slice(0,item.label.length-1)"
                   :clearable="item.unclearable?false:true"
                   @keyup.enter.native="hanClick('sub')">
          <el-option v-for="item in listTypeInfo[item.list]"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-else-if="item.type=='date'"
                        v-model="formInfo.data[item.value]"
                        type="datetime"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <el-date-picker v-else-if="item.type=='dateDay'"
                        v-model="formInfo.data[item.value]"
                        type="date"
                        :disabled="item.disabled"
                        :style="item.style"
                        :clearable="item.unclearable?false:true"
                        placeholder="选择日期"
                        value-format="yyyy-MM-dd"
                        @change="changeDate"
                        @keyup.enter.native="hanClick('sub')">
        </el-date-picker>
        <BoyoUploadtwo v-else-if="item.type=='upload'"
                    :action="action"
                    :src="formInfo.data[item.value]?(imgUrl+formInfo.data[item.value]):null"
                    :value="item.value"
                    :disabled="item.disabled"
                    @on-success="handleAvatarSuccess">
        </BoyoUploadtwo>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import config from '@/api/config'
import BoyoUpload from '@/components/BoyoUpload'
import BoyoUploadtwo from '@/components/BoyoUploadtwo'

export default {
  name: 'BoyoForm',
  components: {
    BoyoUpload,
    BoyoUploadtwo
  },
  props: {
    formInfo: Object,
    refObj: Object,
    listTypeInfo: Object
  },
  data () {
    return {
      checked: false,
      imgUrl: config.pingImgUrl,
      event: '', // 配合select的远程搜索事件
      action: '',
      tPrefixion:localStorage.tPrefixion,
    }
  },
  watch: {
    'formInfo.data' (val) {
      this.$emit('update:refObj', this.$refs.form)
    }
  },
  mounted () {
    this.action = config.upload
    // 将form实例返回到父级
    this.$emit('update:refObj', this.$refs.form)
  },
  methods: {
    // 选择输入框选择事件
    handleSelect (item) {
      this.$emit('handleSelect', item)
    },
    // 选择输入框输入事件
    querySearch (queryString, cb) {
      this.$emit('querySearch', queryString, cb)
    },
    hanClick (event) {
      this.$emit('hanClick', event)
    },
    focus (val) {
      this.event = val
    },
    remoteMethod (query) {
      // console.log(query)
      if (query) {
        this.$emit('formremoteMethod', this.event, query, 'remoteMethod')
      }
    },
    none () {

    },
    selectChange (val, label) {
      this.$emit('formremoteMethod', this.event, val, 'select' + label)
    },
    selectChangeTtext (val) {
      this.$emit('formremoteMethod', this.event, val, 'text')
    },
    changeDate () { // 日期选择发生变化事件
      this.$emit('changeDate')
    },
    checkedChange (event) {
      this.$emit('checkedChange', event)
    },
    handleAvatarSuccess (res, file, fileList, value) {
      this.$emit('on-success', res, file, fileList, value)
    }
  }
}
</script>
<style lang="stylus" scoped>
.form >>>.el-loading-spinner
  padding-right 2px
  box-sizing border-box
  text-align right
  .circular
    height 25px
    width 25px
.form_item_three
  width 30%
  margin-right 0
  text-align left
.form_item_three>>> .el-form-item__content
  width 70%
</style>



// WEBPACK FOOTER //
// src/components/BoyoFormthree/index.vue